export function openReservationModal() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('open-reservation'));
  }
}
